import { PropsWithChildren } from 'react';

import styles from './productPickerLabel.module.css';

export type ProductPickerLabelProps = PropsWithChildren<unknown>;

export const ProductPickerLabel = ({ children }: ProductPickerLabelProps) => <div className={styles.root}>{children}</div>;

export const ProductPickerLabelViewAll = ({ children }: ProductPickerLabelProps) => <div className={styles.viewAll}>{children}</div>;
